<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left list-btn" width="5%">
            <router-link
              :to="{ name: 'adminsDetail', params: { id: props.item.id }}"
            ><i class="fas fa-search"></i></router-link>
          </td>
          <td class="text-xs-left" v-if="visibleDomain" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.domain_name }}</span><pre>{{ props.item.domain_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="20%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.name }}</span><pre>{{ props.item.name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="20%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.email }}</span><pre>{{ props.item.email }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="25%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.desc }}</span><pre>{{ props.item.desc }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</span><pre>{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</pre></v-tooltip></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { adminsEventBus } from '@/components/admin/admins/adminsEventBus';
  import api from '../../../api';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        // NOTE: first init
        isInit: false,
        // NOTE: Table List
        loading: false,
        pagination: {
          sortBy: null,
          descending: null,
          rowsPerPage: 20,
        },
        totalItems: 0,
        visibleDomain: true,
        headers: [
          { text: 'View', value: 'admin_id', align: 'left', sortable: false },
          { text: 'Domain', value: 'domain_name', align: 'left', sortable: false },
          { text: 'Name', value: 'name', align: 'left', sortable: false },
          { text: 'Email', value: 'email', align: 'left', sortable: false },
          { text: 'Description', value: 'description', align: 'left', sortable: false },
          { text: 'Updated At', value: 'updated_at', align: 'left', sortable: false },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['updated_at'],
        // NOTE: Data
        listItems: [],
        filter: [],       // 쿼리문을 담을 배열
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (_.isEmpty(this.storeFilter)) {
          this.getAdminList();
        }
      },
      getAdminList() {
        this.loading = true;
        const sortStr = this.pagination.sortBy;
        let orderStr = null;
        if (this.pagination.descending === null) {
          orderStr = null;
        } else if (this.pagination.descending === false) {
          orderStr = 'asc';
        } else if (this.pagination.descending === true) {
          orderStr = 'desc';
        }
        const querystring = {
          sort: sortStr,
          order: orderStr,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage,
          pagination: true,
        };
        for (let index = 0; index < this.filter.length; index += 1) {
          querystring[this.filter[index].searchCategory] = this.filter[index].search;
        }
        api.getAdminList(querystring)
        .then((result) => {
          if (result.status === 200) {
            this.listItems = result.data.items;
            this.totalItems = result.data.total;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          this.loading = false;
        });
      },
      /**
       * @description 오름차순/내림차순 정렬
       */
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          if (this.isInit) {
            console.log('handler');
            this.getAdminList();
          }
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    created() {
      if (localStorage.getItem('domain_type') !== 'root') {
        this.visibleDomain = false;
        const index = _.findIndex(this.headers, { text: 'Domain' });
        this.headers.splice(index, 1);
      }
    },
    mounted() {
      console.log('adminlist mount');
      this.init();
      // NOTE: 페이지 로드
      this.$nextTick(() => {
        this.isInit = true;
      });
      this.$nextTick(() => {
        if (!_.isEmpty(this.storePage)) {
          this.pagination = Object.assign({}, this.storePage);
          this.getAdminList();
        }
      });
      adminsEventBus.$on('initFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.getAdminList();
      });
      adminsEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        // NOTE: 검색조건이 바뀌므로 첫 페이지로 이동
        this.pagination.page = 1;
        this.getAdminList();
      });
      adminsEventBus.$on('reloadList', () => this.getAdminList());
    },
    updated() {
      storeFilterEventBus.$emit('setPage', this.pagination);
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/admins/AdminsList.vue